module.exports = __webpack_public_path__ + "static/media/0.d4f93176.jpg";